var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { localized, msg } from '@lit/localize';
import {} from '../../../model/Node';
let FormNodeSettings = class FormNodeSettings extends LitElement {
    constructor() {
        super(...arguments);
        this.node = null;
        this.advancedOpen = false;
    }
    handleNodeInputChange(event) {
        const { key, input } = event.detail;
        this.dispatchEvent(new CustomEvent('node-settings-changed', {
            detail: {
                node: this.node,
                change: { key, input },
            },
            bubbles: true,
            composed: true,
        }));
    }
    handleTimeoutChange(event) {
        const value = event.detail;
        const updatedProperties = { ...(this.node?.properties || {}), timeout: value };
        this.dispatchEvent(new CustomEvent('node-properties-changed', {
            detail: {
                node: this.node,
                properties: updatedProperties,
            },
            bubbles: true,
            composed: true,
        }));
    }
    handleNodePortsChange(event) {
        const { ports } = event.detail;
        this.node.output_ports = ports;
        console.log('Updated node ports:', this.node.output_ports);
    }
    render() {
        return html `
      <h3 class="form-node-settings__header">${msg('Form data', { id: 'form.data', desc: 'Form data header' })}</h3>
      <div class="form-node-settings__content">
        ${this.node?.config
            ? html `
          ${Object.entries(this.node.config).map(([key, value]) => html `
              <node-input
                class="form-node-settings__input"
                .key=${key}
                .input=${value}
                .apiService=${this.apiService}
                @node-input-change=${this.handleNodeInputChange}
                @node-ports-change=${this.handleNodePortsChange}
              ></node-input>
              <div class="form-node-settings__input-spacer"></div>
            `)}
        </div>
      `
            : html `<p>${msg('No configuration data available.', { id: 'form.noConfiguration', desc: 'No configuration data error' })}</p>`}
        <div class="form-node-settings__input-spacer"></div>
        <span class="form-node-settings__advanced-toggle" @click=${() => this.advancedOpen = !this.advancedOpen}>
          <span class="form-node-settings__advanced-chevron">${this.advancedOpen ? '▼' : '▶'}</span>
          ${msg('Advanced', { id: 'form.advancedToggle', desc: 'Advanced parameters toggle' })}
        </span>
        ${this.advancedOpen ? html `
          <div class="form-node-settings__advanced-field">
            <label class="form-node-settings__advanced-label">${msg('Timeout (s)', { id: 'form.timeoutLabel', desc: 'Timeout field label' })}</label>
            <input-number
              .value=${this.node?.properties?.timeout ?? 300}
              .min=${0}
              .step=${1}
              size="small"
              variant="secondary"
              placeholder="300"
              @input-number=${this.handleTimeoutChange}
            ></input-number>
          </div>
        ` : ''}
        <div class="form-node-settings__input-spacer"></div>
      </div>
    `;
    }
};
FormNodeSettings.styles = css `
    :host {
      height: 100%;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
    }

    .form-node-settings__header {
      margin: 0;
      font-size: 1rem;
      font-weight: 600;
      padding-bottom: 12px;
      border-bottom: 1px solid #ddd;
      background: #fff;
      position: sticky;
      top: 0;
      z-index: 1;
    }

    .form-node-settings__content {
      box-sizing: border-box;
      flex: 1;
      overflow-y: auto;
      min-height: 0;
    }

    .form-node-settings__input {
      width: 100%;
    }

    .form-node-settings__input-spacer {
      height: 12px;
    }

    .form-node-settings__advanced-toggle {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      font-size: 0.75rem;
      color: #999;
      cursor: pointer;
      user-select: none;
      padding: 2px 0;
      border: none;
      background: none;
    }

    .form-node-settings__advanced-toggle:hover {
      color: #666;
    }

    .form-node-settings__advanced-chevron {
      font-size: 0.6rem;
    }

    .form-node-settings__advanced-field {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 8px 0 4px;
    }

    .form-node-settings__advanced-label {
      font-size: 0.75rem;
      color: #888;
      white-space: nowrap;
    }
  `;
__decorate([
    property({ type: Object })
], FormNodeSettings.prototype, "node", void 0);
__decorate([
    property({ type: Object })
], FormNodeSettings.prototype, "apiService", void 0);
__decorate([
    state()
], FormNodeSettings.prototype, "advancedOpen", void 0);
FormNodeSettings = __decorate([
    localized(),
    customElement('form-node-settings')
], FormNodeSettings);
export { FormNodeSettings };
//# sourceMappingURL=FormNodeSettings.js.map